import { Text } from '@chakra-ui/react';
import { MessageDividerWrapper } from './divider-wrapper';

export type MessageDividerTimeProps = {
  children: React.ReactNode;
};

export const MessageDividerTime = memo(function MessageDividerTime({
  children,
}: MessageDividerTimeProps) {
  return (
    <MessageDividerWrapper>
      <Text fontSize="xs" color="fg.muted" fontWeight="medium">
        {children}
      </Text>
    </MessageDividerWrapper>
  );
});
